import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/ResumeRanap";
import type {LabResult, RadiologiResult, PenunjangLainResult} from "@/types/penunjang_result"

interface ResumeRanap {
  id: number;
  register_id: number;
  pasien_rm: string;
  // unit_id: string;
  tgl_masuk: string;
  tgl_keluar: string;
  dpjp: {
    id: number,
    nama: string,
  };
  dpjp_id: number;
  dr_konsulan: [number];
  dr_raber: [number];
  keluhan_utama: string;
  indikasi_ranap: string;
  riwayat_penyakit: string;
  ringkasan_fisik: string;
  ringkasan_penunjang: string;
  diagnosis_text: string;
  diagnosis: [{
    id: number;
    code: string;
    title: string;
    tgl: string;
    unit_id: string;
    dr_id: string;
    urut: string;
    kasus: string;
  }];
  tindakan: string;
  obat_ranap: string;
  obat_pulang: string;
  tanda_vital: {
    id: number;
    sistole: number;
    diastole: number;
    suhu_badan: number;
    frekuensi_nadi: number;
    frekuensi_nafas: number;
    saturasi_oksigen: number;
    keadaan_umum: string;
    kesadaran: string;
  }
  nyeri: {
    id: number;
    skala: number;
    lokasi: string;
    frekuensi: string;
    durasi: string;
    pencetus: string;
    kualitas: string;
    pola_serangan: string;
    penyebab_hilang: string;
    jenis: string;
    unit_id: string;
  }
  lab_result: Array<LabResult>;
  lis_sampel_items: Array<LabResult>;
  radiologi_result: Array<RadiologiResult>;
  penunjang_lain_result: Array<PenunjangLainResult>;
  discharge_id: number;
  instruksi: string;
  unit_kontrol_id: string;
  tgl_kontrol: string;
  faskes_rujukan_id: string;
  unit_rujukan: string;
  waktu_meninggal: string;
  signed_at: string;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "resume-ranap"
})
class ResumeRanapStore extends VuexModule {
  loading = false;
  resume: ResumeRanap = null;

  @Mutation
  SET_RECORD(val) {
    this.resume = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.resume = null;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_RECORD(response.data?.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(ResumeRanapStore);
